import { External_AWS_CDK_Config, UIBucketsMap } from '@iotv/iotv-v3-types';

export const uiBucketDef: UIBucketsMap = {
  v3: {
    bucketName: 'ui-version-3',
    fwRelativeBase: '../v020',
    uipath: './UIv3',
  },
  v2: {
    bucketName: 'ui-version-2',
    fwRelativeBase: '../v020',
    uipath: './UI',
  },
  v4: {
    bucketName: 'ui-version-4',
    fwRelativeBase: '../v020',
    uipath: './UIv3',
  },
};
